module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_kimono@3x-d6fc9b87ba224dd13dba2418cfb591f4.webp";